import ButtonSymphony from "elements/ButtonSymphony"
import Intercom from "helpers/Intercom"
import { clsx } from "modules/Utils"
import { makeStyles, Theme } from "@material-ui/core"

const NotFoundInstaUser = () => {
    const classes = useStyles()

    return (
        <div className={clsx('notFoundInstaUserMainContainer', classes.mainContainer)}>
            <div className={classes.textContainer}>
                <div className={classes.headerLabel}>
                    Make sure your Instagram is a business or creator account.</div>
                <div className="notFoundInstaUserDescriptionContainer">
                    To track followers, Instagram requires your account to be a creator or business account. We recommend switching to optimize your growth more effectively.&nbsp;
                    <ButtonSymphony
                        className="notFoundInstaUserLearnHowToSwitchButton"
                        style={{ marginTop: 8 }}
                        onClick={() => {
                            Intercom.openInstagramBusinessAccountArticle()
                        }}
                        variant="text"
                    >
                        Learn how to switch to a Business Account &gt;
                    </ButtonSymphony>
                </div>
            </div>
        </div>
    )
}

const useStyles = makeStyles((theme: Theme) => ({
    mainContainer: {
        borderRadius: theme.spacing(1.5),
        backgroundColor: "#FDF6EC",
        marginBottom: 16,
    },
    textContainer: {
        padding: theme.spacing(2),
    },
    headerLabel: {
        color: "#754600",
    },
}));


export default NotFoundInstaUser